import PartnersandMemberships from "./PartnersAndMemberships";

export default PartnersandMemberships;
